import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var gtag: any;

@Injectable({
    providedIn: 'root'
})
export class GtagService {

    constructor() { }

    private trackPageView(value: string) {
        if (!environment.googleTrackingId) {
            return;
        }

        gtag('event', value)
    }

    public trackHome(locale: string) {
        this.trackPageView(`home_${locale}`);
    }

    public trackProduct(productId: string) {
        this.trackPageView(`product_${productId}`);
    }

    public trackProductOffer(productId: string, offerId: string) {
        this.trackPageView(`product_${productId}_offer_${offerId}`);
    }

    public trackProductOfferHostingLocation(productId: string, offerId: string) {
        this.trackPageView(`product_${productId}_offer_${offerId}_hostinglocation`);
    }

    public trackProductOfferConfigCapacitiesOption(productId: string, offerId: string) {
        this.trackPageView(`product_${productId}_offer_${offerId}_config_capacities_options`);
    }

    public trackCart() {
        this.trackPageView(`cart`);
    }

    public trackCartCheckout() {
        this.trackPageView(`cart_checkout`);
    }

    public trackCartSuccess() {
        this.trackPageView(`cart_payment_success`);
    }

    public trackCartError() {
        this.trackPageView(`cart_payment_error`);
    }

    public trackNews(news: string) {
        this.trackPageView(`news_${news}`);
    }
}
